import { render } from "@/components/pages/diagProjectDetails/DiagProjectDetails.html?vue&type=template&id=04e01408&external"
import script from "@/components/pages/diagProjectDetails/DiagProjectDetails.js?vue&type=script&lang=js&external"
export * from "@/components/pages/diagProjectDetails/DiagProjectDetails.js?vue&type=script&lang=js&external"

import "@/components/pages/diagProjectDetails/DiagProjectDetails.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__